import type { JSONContent } from '@tiptap/core';

// Bound both variable segments so malformed token-like input cannot trigger
// unbounded regex backtracking.
const USER_MENTION_PATTERN = /\[([^\]\n]{1,255})\]\(users:(\d{1,20})\)/g;

const parseLine = (line: string): JSONContent[] => {
    const content: JSONContent[] = [];
    let lastIndex = 0;

    for (const match of line.matchAll(USER_MENTION_PATTERN)) {
        const matchIndex = match.index ?? 0;

        if (matchIndex > lastIndex) {
            content.push({ type: 'text', text: line.slice(lastIndex, matchIndex) });
        }

        content.push({
            type: 'mention',
            attrs: {
                id: match[2],
                label: match[1],
            },
        });
        lastIndex = matchIndex + match[0].length;
    }

    if (lastIndex < line.length) {
        content.push({ type: 'text', text: line.slice(lastIndex) });
    }

    return content;
};

export const parseNoteContent = (content?: string | null): JSONContent => ({
    type: 'doc',
    content: (content ?? '').split('\n').map((line) => {
        const paragraphContent = parseLine(line);

        return {
            type: 'paragraph',
            ...(paragraphContent.length > 0 ? { content: paragraphContent } : {}),
        };
    }),
});

const serializeNode = (node: JSONContent): string => {
    if (node.type === 'text') {
        return node.text ?? '';
    }

    if (node.type === 'mention') {
        return `[${String(node.attrs?.label ?? '')}](users:${String(node.attrs?.id ?? '')})`;
    }

    if (node.type === 'hardBreak') {
        return '\n';
    }

    return (node.content ?? []).map(serializeNode).join('');
};

export const serializeNoteContent = (document: JSONContent): string =>
    (document.content ?? []).map(serializeNode).join('\n');
